export interface DisconnectCopy {
  name: string;
  description: string;
}

export const DISCONNECT_COPY = {
  razorpay: {
    name: 'Razorpay',
    description:
      'Payment links, plans and subscriptions will stop working until you reconnect. You can reconnect anytime.',
  },
  payu: {
    name: 'PayU',
    description:
      'New payments through PayU — UPI, cards, and netbanking — will stop being accepted until you reconnect. Existing payment records are preserved.',
  },
  cashfree: {
    name: 'Cashfree',
    description:
      'New payments through Cashfree will stop being accepted until you reconnect. Existing payment records are preserved.',
  },
  woocommerce: {
    name: 'WooCommerce',
    description:
      'Product and order syncing with your WooCommerce store will stop until you reconnect. Already-synced data is preserved.',
  },
  uberdirect: {
    name: 'Uber Direct',
    description:
      "You won't be able to create or track Uber Direct deliveries until you reconnect. Existing delivery records are preserved.",
  },
  instagram: {
    name: 'this account',
    description:
      'This permanently deletes every post, scheduled post, draft, and inbox conversation for this account — this cannot be undone. Automations tied to it will also stop working.',
  },
  facebook: {
    name: 'this page',
    description:
      'This permanently deletes every post, scheduled post, draft, and inbox conversation for this page — this cannot be undone. Automations tied to it will also stop working.',
  },
  linkedin: {
    name: 'this account',
    description:
      'This permanently deletes every scheduled post and draft for this account — this cannot be undone. Automations tied to it will also stop working.',
  },
  youtube: {
    name: 'this channel',
    description:
      "This permanently deletes every synced video, comment and comment-automation rule for this channel — this cannot be undone. WeNext's access is revoked at Google, so reconnecting means authorizing again.",
  },
  tiktok: {
    name: 'this account',
    description:
      'Scheduled posts and automations tied to this account will stop working until you reconnect. Historical data will be preserved.',
  },
  googleCalendar: {
    name: 'Google Calendar',
    description:
      'New bookings will stop syncing to your Google Calendar and real-time conflict checking will be disabled until you reconnect. Events already on your calendar are preserved.',
  },
  googleSheets: {
    name: 'Google Sheets',
    description:
      'Automatic syncing of your data to Google Sheets will stop until you reconnect. Data already in your spreadsheets is preserved.',
  },
  zoom: {
    name: 'Zoom',
    description:
      'New bookings will stop getting Zoom meeting links until you reconnect. Meetings already scheduled keep their existing links.',
  },
} satisfies Record<string, DisconnectCopy>;

export type DisconnectIntegration = keyof typeof DISCONNECT_COPY;
